import {DataTable} from "../DataTable/DataTable";
import {ObjectChangeLogEntry} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {DefaultText} from "../../text/DefaultText/DefaultText"
import {FormattedDateTime} from "../../date/FormattedDateTime/FormattedDateTime";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {usePagination} from "../DataTable/usePagination";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";

const EMPTY_ARRAY: ObjectChangeLogEntry[] = []

export type ObjectChangeLogDataTableProps = EntityDataTableProps<ObjectChangeLogEntry>

export const ObjectChangeLogDataTable = (props: ObjectChangeLogDataTableProps) => {
  const {
    records: changeLogs = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: changeLogs,
    sortStatus: {columnAccessor: 'createDttm', direction: 'desc'},
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  return (
    <DataTable
      {...rest}
      {...(pagination ?? {})}
      sortStatus={sortStatus}
      onSortStatusChange={onSortStatusChange}
      columns={[
        {
          title: t("table.entity.objectchangelog.column.field", "Field"),
          accessor: "fieldName",
          width: 100,
          render: ({fieldName}) => (<DefaultText value={fieldName}/>)
        },
        {
          title: t("table.entity.objectchangelog.column.fromvalue", "Original Value"),
          accessor: "fromValue",
          width: 100,
          render: ({fromValue}) => (<DefaultText value={fromValue}/>)
        },
        {
          title: t("table.entity.objectchangelog.column.tovalue", "New Value"),
          accessor: "toValue",
          width: 100,
          render: ({toValue}) => (<DefaultText value={toValue}/>)
        },
        {
          title: t("table.entity.objectchangelog.column.createdbyperson", "User"),
          accessor: "createdByPersonName",
          width: 100,
          render: ({createdByPersonId, createdByPersonName}) => (
            createdByPersonId ? <DefaultText value={createdByPersonName}/> : "System User")
        },
        {
          title: t("table.entity.objectchangelog.column.createttm", "Date"),
          accessor: "createDttm",
          width: 100,
          render: ({createDttm}) => (<FormattedDateTime date={createDttm}/>)
        },
      ]}
    />
  );
};
